import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SelectProjectGroupComponent } from '../../project/select-project-group/select-project-group.component';
import { C4ListResponse, ProjectGroupResponse, RestService } from 'cargo-chief-commons';
import { lastValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ProjectGroupService {
	constructor(
		private utilService: UtilService,
		private dialog: MatDialog,
		private urlService: UrlService,
		private restService: RestService
	) {}

	async selectProjectGroup(
		projectId: string
	): Promise<{ projectGroupId?: string; projectHasNoGroups?: boolean } | null> {
		const url = this.urlService.getProjectGroups();
		const payload = {
			projectId,
			withProjectCarrierMaps: false,
		};
		const projectGroupListResponse: C4ListResponse<ProjectGroupResponse> = await lastValueFrom(
			this.restService.POST(url, payload)
		);
		const projectGroupList = (projectGroupListResponse && projectGroupListResponse.data) || [];
		const projectGroupsCount = projectGroupList.length;
		if (projectGroupsCount == 1) {
			return new Promise((resolve) => resolve({ projectGroupId: projectGroupList[0].id }));
		} else if (projectGroupsCount > 1) {
			const dialogRef = this.dialog.open(SelectProjectGroupComponent, {
				width: '500px',
				disableClose: true,
				data: { projectGroupList },
			});
			return dialogRef.afterClosed().toPromise();
		}
		return new Promise((resolve) => resolve({ projectHasNoGroups: true }));
	}
}
